import { isEqual } from 'lodash'

import type { Command } from 'common/Prose/Commands'
import { JoinListsMetaKey } from 'common/Prose/Plugins/JoinLists'
import { getListFormatAttrs } from 'common/Prose/utils'

export const joinListsByDeletion: Command = ({ doc, selection: { $from, $to }, tr }, dispatch) => {
  // NOTE: If we are not deleting some full nodes
  if ($from.pos !== $from.start() || $to.pos !== $to.end()) return false

  if ($to.node() === doc || $from.node() === doc) return false

  // NOTE: if the deleted nodes are not followed by a list
  const $after = doc.resolve($to.after())
  if (!$after.nodeAfter?.type.groups.includes('list')) return false

  // NOTE: if the deleted nodes are not following a list
  const $before = doc.resolve($from.before())
  if (!$before.nodeBefore?.type.groups.includes('list')) return false

  // NOTE: if the preceding and following lists are not of the same type
  if ($after.nodeAfter.type !== $before.nodeBefore.type) return false
  if (!isEqual(getListFormatAttrs($after.nodeBefore), getListFormatAttrs($before.nodeBefore))) return false

  tr.delete($from.before(), $to.after())
  tr.setMeta(JoinListsMetaKey, $from.before()) // NOTE: only one tr per command, but we want two, so delegate to a plugin
  dispatch?.(tr)

  return true
}
